/**
 * Formats an API timestamp as its UTC calendar date ("Sep 15, 2026"), so the
 * Students table shows the same day as the CSV and server exports (SOPHIA-35638).
 */
export function formatUtcDate(timestamp: string): string {
  return new Date(timestamp).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}
